import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import errors from './errors';

import {
  ACTION_ADD_SITE_ALIASES,
  ACTION_DELETE_SITE_ALIAS__REQUEST,
  ACTION_DELETE_SITE_ALIAS__SUCCESS,
  ACTION_DELETE_SITE_ALIAS__FAIL,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_SITE_ALIASES:
      return { ...state, ...action.payload.siteAliases };

    case ACTION_DELETE_SITE_ALIAS__SUCCESS:
      return _omit(state, action.payload.siteAliasId);

    default:
      return state;
  }
};

const isSiteAliasBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_ALIAS__REQUEST:
      return { ...state, [action.payload.siteAliasId]: true };

    case ACTION_DELETE_SITE_ALIAS__SUCCESS:
    case ACTION_DELETE_SITE_ALIAS__FAIL:
      return _omit(state, action.payload.siteAliasId);

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  isSiteAliasBeingDeleted,
  errors,
});
